import Image from "next/image";

import HeroSearchBox from "@/elements/HeroSearchBox";
import CountUpBox from "@/elements/CountUpBox";
import { ExploreMore } from "@/elements/Button/Button";
import { useRouter } from "next/router";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { UserDetailProvider } from "@/contexts/UserDetailContext";
import { useContext, useEffect } from "react";
import ratingsLogo from "../../assets/Images/rating.png";
import TrialCountdown from "../ProPage2/TrialCountdown";
import leftIcon from "../../assets/Images/left.png";
import rightIcon from "../../assets/Images/right.png";
import pro from "../../assets/icons/pro/pro_light.png";
import infoIcon from "../../assets/Images/infoIcon.png";
import { popUp as popUpSEBI } from "@/elements/PopUp/SEBIPopUp";
import { popUp } from "@/elements/PopUp/PopUp";
import dynamic from "next/dynamic";
import RatioBar from "../ProPage2/RatioBar";
import { useGetAxios } from "@/hooks/useGetAxios";
import { Mixpanel } from "@/elements/Mixpanel";
import get_5_free_trades from "@/assets/get_5_free_trades.webp";

const ServerSideText = dynamic(() => import("@/elements/ServerSideText"), { ssr: false });

export default function ProHeroSection({ homePage, isDark }) {
    const router = useRouter();
    const userDetail = useContext(UserDetailProvider);

    const submit = () => {
        router.push("/user/log-in");
        // if (userDetail?.userData?.authToken) {
        // popUp.open(userDetail)
        // } else {
        //     var IndNum = /^[0]?[6789]\d{9}$/;
        //     if (number.length === 10 && IndNum.test(number)) {
        //         axiosInterceptorInstance.get(`api/auth/send-otp?type=web&countryCode=91&contactNumber=${number}`)
        //         setModal(true)
        //         Mixpanel.track('lead_submitted', {
        //             'cta_text': userDetail?.btn?.beforeLogin,
        //             'page': userDetail?.btn?.page,
        //             'phone_filled': true,
        //             'widget': 'bottom_sticky'
        //         })
        //         Mixpanel.pageView({
        //             'page': 'web_otp_page'
        //         })
        //     } else if (number.length === 0) {
        //         setError('Mobile number is required')
        //     } else {
        //         setError('Please enter a valid mobile number')
        //     }
        // }
    };

    const sendEvent = (type) => {
        Mixpanel.track("chip_clicked", {
            cta_clicked: "my_profile_web",
            chip_type: type,
            page: "web_pro_page"
        });
    };

    return (
        <section id="Hero" className=" overflow-hidden bg-gradient-to-b from-[#343434] to-[#343434]">
            <div className=" w-full flex flex-row pt-[176px] pb-[120px] max-w-screen-xl mx-auto justify-between  items-center gap-20">
                <div className="flex flex-col items-start gap-6">
                    <div className=" top-0 flex items-center justify-center">
                        <div
                            className={`text-white text-[36.198px] font-bold leading-[normal]  ${
                                !isDark ? "text-white" : "text-[#414141]"
                            }`}
                        >
                            Univest
                        </div>
                        <Image src={pro} alt="icon" className="w-[78px] object-contain ml-2" />
                    </div>
                    <div className="  font-Inter basis-full md:basis-7/12 flex flex-col content-start relative">
                        <span
                            className={`text-[color:var(--Pearl-White,#FFF)]  text-5xl font-extrabold leading-[80px] ${
                                !isDark ? "text-white" : "text-[#414141]"
                            }`}
                        >
                            India’s trusted
                        </span>
                        <span
                            className={`text-[color:var(--Pearl-White,#FFF)]  text-5xl font-extrabold leading-[80px] ${
                                !isDark ? "text-white" : "text-[#414141]"
                            }`}
                        >
                            Stock market ideas
                        </span>
                    </div>
                    <div className="flex items-center">
                        <p className={`font-semibold text-base text-white`}>Powered by SEBI Reg. RA Uniresearch</p>
                        <AiOutlineInfoCircle
                            color="#FFFFFF"
                            className="text-[16px] ml-2 cursor-pointer"
                            onClick={(e) => {
                                popUpSEBI.open("uniresearch");
                            }}
                        />
                    </div>
                    {
                        <>
                            <button
                                className={`font-Inter relative w-full text-black text-center buy-button pt-4 hover:animate-none`}
                                onClick={submit}
                            >
                                <ServerSideText
                                    text="Activate FREE trial"
                                    className="absolute text-sm font-extrabold left-1/2 translate-y-1/3 -translate-x-1/2 whitespace-nowrap"
                                />
                                <div className="buttont"></div>
                                <div className="buttonb"></div>
                            </button>
                            <style>
                                {`
                            .buttont {
                                height: 36px;
                                width: 100%;
                                color:#fff;
                                border-bottom: 36px solid #fff;
                                border-left: 16px solid transparent;
                                border-right: 16px solid transparent;
                                }
                            .buttonb {
                                height: 2px;
                                width: 100%;
                                color:#FFCA3F;
                                border-top: 12px solid #FFCA3F;
                                border-left: 4px solid transparent;
                                border-right: 4px solid transparent;
                                }
                            @keyframes buy-bounce {
                                0%, 100% {
                                    transform: translateY(-10%);
                                    animation-timing-function: cubic-bezier(0.5,0,1,1);
                                }
                                50% {
                                    transform: none;
                                    animation-timing-function: cubic-bezier(0,0,0.2,1);
                                }
                            }
                            .buy-button {
                                animation: buy-bounce 1s;
                                animation-iteration-count: infinite;
                            }
                            `}
                            </style>
                        </>
                    }
                </div>
                <div
                    className={`basis-full md:basis-5/12 flex content-center relative ${
                        homePage ? "mt-12 lg:mt-4" : "mt-6"
                    }`}
                >
                    <img
                        src={get_5_free_trades.src}
                        alt="get_5_free_trades"
                        width={984}
                        height={552}
                        className="w-full"
                    />
                </div>
            </div>
            {!homePage && (
                <div className="mt-8  lg:gap-16 [background:var(--Questionnaire-background-color,linear-gradient(127deg,#DDF6FF_-31.48%,#FFEAEF_95.46%))] px-4 py-2 lg:px-20 lg:py-4 flex whitespace-nowrap justify-center items-center">
                    <div className="flex items-center gap-2 lg:gap-4">
                        <p className="text-black text-sm font-medium leading-6  lg:text-[28px] lg:font-semibold lg:leading-[49px]">
                            Trusted by
                        </p>
                        <p className="text-black text-xl font-extrabold leading-8 lg:text-[40px] lg:font-extrabold lg:leading-[65.333px]">
                            40lakhs+ users
                        </p>
                    </div>
                    <Image className="w-[116px] h-[21px] lg:w-[260px] lg:h-[48px]" src={ratingsLogo} alt="demo" />
                </div>
            )}
            {userDetail?.userData?.subscriptionState === "TRIAL_PRO_SUPER" && !homePage && (
                <div className="relative w-full my-20 inline-flex flex-col justify-center items-center gap-20">
                    <Image className="absolute top-0 -right-4  w-[116px] h-[362px] " src={rightIcon} alt="demo" />
                    <Image
                        className="absolute top-0 -left-6 rotate-6  w-[116px] h-[362px] "
                        src={leftIcon}
                        alt="demo"
                    />
                    <TrialCountdown className="px-4" endTime={userDetail?.userData?.expiryDate} />
                </div>
            )}
            {!homePage && (
                <div className=" flex justify-center py-6 md:hidden ">
                    <p className="font-Inter font-bold text-white text-sm lg:text-2xl">PRO membership benefits</p>
                </div>
            )}
        </section>
    );
}
